import Head from 'next/head';
import { useEffect, useState, type ReactElement } from 'react';
// Book buttons moved to global header
import { supabase } from '../lib/supabaseClient';
import { HeroSection } from '@/components/home/hero-section';
import { AccessCards } from '@/components/home/access-cards';
import { FeaturesSection } from '@/components/home/features-section';
import { TrustSection } from '@/components/home/trust-section';

export default function About(): ReactElement {
  const [user, setUser] = useState<unknown | null>(null);
  
  useEffect((): (() => void) => {
    const run = async (): Promise<void> => {
      const { data } = await supabase.auth.getSession();
      setUser(data?.session?.user ?? null);
    };
    void run();
    const { data: listener } = supabase.auth.onAuthStateChange((_e, session) => setUser(session?.user ?? null));
    return () => listener.subscription.unsubscribe();
  }, []);

  return (
    <>
      <Head>
        <title>About KEM Discovery - Understanding Your Key Emotional Motivators</title>
        <meta name="description" content="Learn about KEM Discovery's science-backed approach to understanding your Key Emotional Motivators. Discover how our assessment helps individuals and teams unlock their potential." />
      </Head>
      
      {/* About header with CTA cards and jump link to features */}
      <HeroSection isAuthenticated={!!user} showAccessCards={false}>
        <AccessCards />
      </HeroSection>

      {/* Reuse the same features/trust sections for now */}
      <FeaturesSection />

      <TrustSection />
    </>
  );
}

